import { render, staticRenderFns } from "./DocumentRule.vue?vue&type=template&id=91b0c89e&scoped=true"
import script from "./DocumentRule.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DocumentRule.vue?vue&type=style&index=0&id=91b0c89e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b0c89e",
  null
  
)

export default component.exports